export default __webpack_public_path__ + "static/media/TRR-drink-matcha-blossom.64ceb159.png";